import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';

import Link from '../../Core/Link';

import { AppStoreContainer, StyledImage } from './style';

const AppStores = ({ badges, direction = 'row' }) => {
  if (!badges) return null;

  return (
    <AppStoreContainer className={direction}>
      {badges.map(badge => {
        const isSVG = badge.iconDam.asset.mimeType === 'image/svg+xml';
        return isSVG ? (
          <Link className="unstyled-link" key={badge.id} data={badge}>
            <SVG
              src={badge.iconDam.asset.localImage.publicURL}
              title={badge.iconDam.altText || ''}
            />
          </Link>
        ) : (
          <Link className="unstyled-link" key={badge.id} data={badge}>
            <StyledImage src={badge.iconDam} altText={badge.iconDam.altText} />
          </Link>
        );
      })}
    </AppStoreContainer>
  );
};

AppStores.propTypes = {
  badges: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  direction: PropTypes.string,
};

export default AppStores;
